import { ASSOCIATION_PAGE } from 'config';
import { useSlideoutStore } from '../stores/useSlideoutStore';
import { useModalOverlayStore } from '../stores/useModalOverlayStore';
import { loadOverlayComponent } from './loadOverlayComponent';
import { restoreBodyScroll } from './restoreBodyScroll';

export default async () => {
  const slideout = useSlideoutStore();
  const modalOverlay = useModalOverlayStore();
  const component = await loadOverlayComponent('emailVerify');
  slideout.close('manage-membership-slideout');
  restoreBodyScroll();
  modalOverlay.setModalOverlay({
    width: '35.714rem',
    id: 'emailVerifyOverlay',
    title: `${ASSOCIATION_PAGE.TWO_STEP_VERIFICATION}`,
    component,
  });
  modalOverlay.toggle('emailVerifyOverlay');
};
